type FailedRequest = {
  method: string;
  url: string;
  status: number;
  duration: number;
};

const MAX_FAILED_REQUESTS = 10;
const MAX_CONSOLE_ERRORS = 10;

export const failedRequests: FailedRequest[] = [];
export const consoleErrors: string[] = [];

export function trackFailedRequest(req: FailedRequest) {
  failedRequests.push(req);
  if (failedRequests.length > MAX_FAILED_REQUESTS) failedRequests.shift();
}

if (typeof window !== "undefined") {
  const origError = console.error;
  console.error = (...args: unknown[]) => {
    const msg = args
      .map((a) => (typeof a === "string" ? a : String(a)))
      .join(" ");
    consoleErrors.push(msg);
    if (consoleErrors.length > MAX_CONSOLE_ERRORS) consoleErrors.shift();
    origError.apply(console, args);
  };
}
